import { render, staticRenderFns } from "./json-tree.vue?vue&type=template&id=ef08367c&scoped=true&"
import script from "./json-tree.vue?vue&type=script&lang=js&"
export * from "./json-tree.vue?vue&type=script&lang=js&"
import style0 from "./json-tree.vue?vue&type=style&index=0&id=ef08367c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef08367c",
  null
  
)

component.options.__file = "json-tree.vue"
export default component.exports